var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hospitals-search-tools'),_c('hospitals-search-table'),_c('hospitals-edit-popup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }